import React, { useState } from "react";
import {
  Calendar as AntCalendar,
  Badge,
  Col,
  Form,
  message,
  Modal,
  Popover,
  Row,
  Table,
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import StaffLeaveIndicatorInCalendar from "molecules/StaffLeaveIndicatorInCalendar";
import {
  dateInDetail,
  getMySqlDate,
  isDateBetweenTwoDates,
  momentDate,
} from "utils/Date";
import LeaveList from "organisms/LeaveList";
import { CALL_API } from "common/API";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import download from "downloadjs";
import {
  getClientid,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { useSelector } from "react-redux";
import ViewDocument from "reusableComponent/Popup/viewDocument";
import { ReactComponent as HomeIcon } from "assets/wfhicon.svg";
import { ReactComponent as LeaveIcon } from "assets/leaveicon.svg";
import { ReactComponent as OvertimeIcon } from "assets/overtimeicon.svg";
import { ReactComponent as TimeoffIcon } from "assets/timeoff.svg";
import styled from "styled-components";
import COLORS from "common/Colors";
import { DEVICE } from "common/Device";
import TextArea from "antd/lib/input/TextArea";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CloseOutlined } from "@mui/icons-material";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";

const StyledTable = styled(Table)`
  //   padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
    border: none !important;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }
  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const StyledDateCell = styled.div`
  padding: 5px;
  .ant-picker-calendar-full
    .ant-picker-panel
    .ant-picker-calendar-date-content {
    height: 120px !important;
  }
  .day {
    padding: 6px 5px;
    border-radius: 50px;
    font-size: 0.8rem;
    font-weight: bold;
  }
  .has-pending-leaves {
    background: ${COLORS.PENDING_LEAVE};
    color: ${COLORS.WHITE};
  }
  .hr-leave-container {
    text-align: center;
    padding-top: 50px;

    .ant-badge-count {
      min-width: 30px !important;
      height: 30px !important;
      line-height: 30px !important;
      border-radius: 50px;
      font-size: 14px;
      box-shadow: 0px 1px 5px #6f6f6f;
      font-weight: bold;
    }
    @media (max-width: 935px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    @media (max-width: 762px) {
      .ant-badge-count {
        min-width: 30px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    @media (max-width: 600px) {
      .ant-badge-count {
        min-width: 15px !important;
        height: 15px !important;
        line-height: 15px !important;
      }
    }
    .hr-has-pending-leaves {
      margin-right: 2px;
      .ant-badge-count {
        background: ${COLORS.PENDING_LEAVE};
      }
    }
  }
  .hr-has-approved-leaves {
    margin-left: 3px;
    .ant-badge-count {
      background: ${COLORS.APPROVED_LEAVE};
    }
  }
  @media ${DEVICE.mobileL} {
    padding: 0px;
    height: 100px;
    .hr-leave-container {
      padding-top: 0px;
    }
  }
  .has-approved-leaves {
    background: ${COLORS.APPROVED_LEAVE};
    color: ${COLORS.WHITE};
  }
  .ant-picker-calendar-date-content {
    height: 46px;
    margin-top: 5px;
  }
`;

const StyledHolidayBadge = styled(Badge)`
  margin-top: 5px;
  background: red;
  padding: 5px;
  color: white;
  border-radius: 50%;
  font-size: 9px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -2px;
  right: 14px;
`;

const StyledDiv = styled.div`
  .label {
    color: #8b8b8b;
    font-weight: 500;
  }
  .value {
    color: #1f1f1f;
    font-weight: 500;
  }
  .attachment {
    color: #2d53da;
    cursor: pointer;
  }
`;

const StyledAntCalendarFull = styled(AntCalendar)`
  background: transparent !important;
  width: 100% important;

  .ant-picker-calendar-date {
    min-height: 140px !important;
  }

  .ant-picker-calendar-date-content {
    height: 120px !important;
    margin-top: 5px;
  }

  .ant-picker-calendar-header {
    display: none;
  }
  .ant-picker-panel {
    background: transparent !important;
  }
  .ant-picker-cell-selected .ant-picker-calendar-date,
  .ant-picker-cell-selected:hover .ant-picker-calendar-date {
    background: transparent !important;
    border: none !important;
  }

  .ant-picker-cell-selected .ant-picker-calendar-date-value {
    color: inherit !important;
  }
  .ant-picker-cell-today .ant-picker-calendar-date-value {
    color: #fff !important;
    background: #1e2d47;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    // font-weight: bold;
  }
  .ant-picker-calendar-date-value {
    font-weight: 600;
    padding-left: 4px;
  }
  .ant-picker-cell,
  th {
    border: solid 1px #9c9c9c;
    text-align: left;
  }
  th {
    width: 100px;
    padding: 10px !important;
    text-align: center;
    font-weight: bold;
    border-bottom: none;
  }
  th:nth-child(1):after {
    content: "UN";
  }
  th:nth-child(2):after {
    content: "ON";
  }
  th:nth-child(3):after {
    content: "UE";
  }
  th:nth-child(4):after {
    content: "ED";
  }
  th:nth-child(5):after {
    content: "HU";
  }
  th:nth-child(6):after {
    content: "RI";
  }
  th:nth-child(7):after {
    content: "AT";
  }
  .ant-picker-cell-in-view {
    color: ${COLORS.BLACK};
  }
  tbody tr:nth-child(1) td {
    border-top: none !important;
  }

  @media ${DEVICE.mobileL} {
    th {
      font-size: 10px;
      font-weight: 500px;
      width: 100% !important;
      text-align: left;
      padding: 0 !important;
    }
  }
`;

const ModalWrap = styled(Modal)`
  .ant-modal-content {
    border-radius: 14px;
    padding: 10px 8px 0px 8px;
  }
  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }
  .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    margin-top: -12px;
  }
  .ant-modal-body {
    padding: 10px 20px 24px;
  }
  .top-icons {
    position: absolute;
    right: 55px;
    top: 18px;
    display: flex;
    gap: 18px;
    font-size: 18px;
    color: #5b6fd6;
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    right: 20px;
    top: 18px;
    font-size: 18px;
    cursor: pointer;
    color: #666;
  }
  .applied-tag {
    background: #e9ecfb;
    border-radius: 20px;
    padding: 3px 14px;
    font-size: 13px;
    margin-bottom: 18px;
    display: inline-block;
  }
  .label {
    color: #8b8b8b;
    font-weight: 500;
  }
  .value {
    color: #1f1f1f;
    font-weight: 500;
  }
  .attachment {
    color: #2d53da;
    cursor: pointer;
  }
  .reason-title {
    margin-top: 16px;
    color: #8b8b8b;
    font-weight: 500;
  }
  .reason-text {
    margin-top: 6px;
    color: #1f1f1f;
    line-height: 1.6;
  }
  @media (max-width: 768px) {
    .value {
      text-align: left;
      margin-top: 4px;
    }
    .top-icons {
      right: 45px;
      gap: 12px;
    }
    .ant-modal-body {
      padding: 10px 14px 22px;
    }
  }
`;

// ⚠️ antd v4 CSS import — add this in your index.js or App.js (NOT here):
// import 'antd/dist/antd.css';

// ─── SVG Icons ────────────────────────────────────────────────────────────────

// ─── Your Real Data ───────────────────────────────────────────────────────────

// ─── Main Component ───────────────────────────────────────────────────────────
export default function CustomCalendar({
  tabId,
  holidayList,
  miniCalendarCurrentDate,
  addLeave,
  Menulist,
  leaveList = [],
  timeoffList = [],
  wfhList = [],
  overtimeList = [],
  toggleLeaveModal,
  getLeaveList,
  setLeaveDetails,
  handleEditIconClick,
  getData = () => {},
}) {
  const { t } = useTranslation();
  const users = useSelector(getUserList);
  const userRoleId = useSelector(getUserRoleId);
  const ClientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const [updateform] = Form.useForm();

  const [value, setValue] = useState(dayjs());
  const [calendarKey, setCalendarKey] = useState(0);
  const [isLeaveListModalVisible, toggleLeaveListModalVisible] =
    useState(false);
  const [leaveListModalVisible, setLeaveListModalVisible] = useState(false);
  const [selectedEventDetails, setSelectedEventDetails] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [preview, setPreview] = useState(false);
  const [status, setStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [hoverStatus, setHoverStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("0");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [approveConfirmVisible, setApproveConfirmVisible] = useState(false);

  const handleFinish = async (status, viewData, value) => {
    try {
      setUpdateLoading(true);
      let payload = {};
      let requestType = "";

      if (selectedType === "wfh") {
        requestType = "wfhrequest";
        payload = {
          wfhStartDate: dayjs(viewData?.wfhStartDate).format("YYYY-MM-DD"),
          wfhEndDate: dayjs(viewData?.wfhEndDate).format("YYYY-MM-DD"),
          wfhNoofDays: String(viewData?.wfhNoofDays),
          wfhReason: viewData?.wfhReason,
          reportingManager: viewData?.reportingManager,
          objectKey: viewData?.objectKey || "",
          fileName: viewData?.fileName || "",
          statusId: status,
          rejectReason: value?.decline_reason || "",
          requestType,
          approved_rejected_byName: userInfo?.name,
        };
      } else if (selectedType === "timeoff") {
        requestType = "permissionrequest";
        payload = {
          permissionDate: viewData?.permissionDate
            ? dayjs(viewData.permissionDate).format("YYYY-MM-DD")
            : "",
          permissionTime: viewData?.permissionTime,
          compensatingDate: viewData?.compensatingDate,
          permissionReason: viewData?.permissionReason,
          reportingManager: viewData?.reportingManager,
          objectKey: viewData?.objectKey || "",
          fileName: viewData?.fileName || "",
          statusId: status,
          rejectReason: value?.decline_reason || "",
          requestType,
          approved_rejected_byName: userInfo?.name,
        };
      } else {
        requestType = "overtimerequest";
        payload = {
          overtimeDate: viewData?.overtimeDate
            ? dayjs(viewData.overtimeDate).format("YYYY-MM-DD")
            : "",
          overtimeTime: viewData?.overtimeTime,
          overtimeReason: viewData?.overtimeReason,
          reportingManager: viewData?.reportingManager,
          objectKey: viewData?.objectKey || "",
          fileName: viewData?.fileName || "",
          statusId: status,
          rejectReason: value?.decline_reason || "",
          requestType,
          approved_rejected_byName: userInfo?.name,
        };
      }

      const { code } = await CALL_API(
        `employeerequest/${viewData?.userId}/${viewData?.requestId}?requestType=${requestType}`,
        "patch",
        payload
      );

      if (code === STATUS_CODE.SUCCESS) {
        setApproveConfirmVisible(false);
        setPopupOpen(true);
        setOpen(false);
        setIsOpenModal(false);
        setTimeout(() => {
          setPopupOpen(false);
          updateform.resetFields();
          getData("wfhrequest");
          getData("permissionrequest");
          getData("overtimerequest");
        }, 2000);
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    } finally {
      setUpdateLoading(false);
    }
  };

  const handlePreviewClick = async (data, type) => {
    try {
      const ext = data?.fileName?.split(".")?.pop();
      setLoading(true);
      const { code, url } = await CALL_API(
        `employeerequest/file?userId=${data?.userId}&requestId=${data?.requestId}&requestType=${type}`,
        "get",
        {}
      );
      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(ext)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
        }
      } else {
        message.error(t("Preview failed. Try again."));
      }
    } catch {
      message.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const hasActionableRecords = selectedEventDetails?.some(
    (record) => record?.statusId === "0"
  );

  const overtimeColumns = [
    {
      title: t("Name"),
      dataIndex: "userId",
      key: "overtime_name",
      render: (text) => users?.find((val) => val?.userid === text)?.fullname,
    },
    {
      title: t("Employee ID"),
      dataIndex: "userId",
      key: "overtime_empid",
      render: (text) => users?.find((val) => val?.userid === text)?.employeeid,
    },
    {
      title: t("Date - Day"),
      dataIndex: "overtimeDate",
      key: "overtimeDate",
      width: 150,
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Time"),
      dataIndex: "overtimeTime",
      key: "overtimeTime",
      width: 150,
      render: (date) => dayjs(date)?.format("HH [hrs] mm [mins]"),
    },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "overtime_file",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record, "overtimerequest");
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Applied on"),
      dataIndex: "createdAt",
      key: "overtime_createdAt",
      width: 150,
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Reason for Overtime"),
      dataIndex: "overtimeReason",
      key: "overtimeReason",
      width: 150,
      className: "reason-column",
    },

    ...(hasActionableRecords
      ? [
          {
            title: t("Action"),
            key: "overtime_action",
            width: 180,
            render: (_, record) => (
              <div
                style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
              >
                <ButtonOutlined
                  onClick={() => {
                    setSelectedRecord(record);
                    setOpen(false);
                    setLeaveListModalVisible(false);
                    setIsOpenModal(true);
                  }}
                >
                  Decline
                </ButtonOutlined>
                <ButtonFilled
                  onClick={() => {
                    setSelectedRecord(record);
                    setLeaveListModalVisible(false);
                    setApproveConfirmVisible(true);
                  }}
                  loading={updateLoading}
                >
                  Approve
                </ButtonFilled>
              </div>
            ),
          },
        ]
      : []),
  ];

  const wfhColumns = [
    {
      title: t("Name"),
      dataIndex: "userId",
      key: "wfh_name",
      render: (text) => users?.find((val) => val?.userid === text)?.fullname,
    },
    {
      title: t("Employee ID"),
      dataIndex: "userId",
      key: "wfh_empid",
      render: (text) => users?.find((val) => val?.userid === text)?.employeeid,
    },
    {
      title: t("Start Date"),
      dataIndex: "wfhStartDate",
      key: "wfhStartDate",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("End Date"),
      dataIndex: "wfhEndDate",
      key: "wfhEndDate",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    { title: t("Total Days"), dataIndex: "wfhNoofDays", key: "wfhNoofDays" },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "wfh_file",
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record, "wfhrequest");
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Applied on"),
      dataIndex: "createdAt",
      key: "wfh_createdAt",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Reason for WFH"),
      dataIndex: "wfhReason",
      key: "wfhReason",
      className: "reason-column",
    },
    // {
    //   title: t("Action"),
    //   key: "action",
    //   width: 180,
    //   render: (_, record) => {
    //     console.log(record?.statusId, "record321", record);
    //     return (
    //       record?.statusId === "0" && (
    //         <div
    //           style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
    //         >
    //           <ButtonOutlined
    //             onClick={() => {
    //               setSelectedRecord(record);
    //               setOpen(false);
    //               setLeaveListModalVisible(false);
    //               setIsOpenModal(true);
    //             }}
    //           >
    //             Decline
    //           </ButtonOutlined>
    //           <ButtonFilled
    //             onClick={() => {
    //               setSelectedRecord(record);
    //               setLeaveListModalVisible(false);
    //               setApproveConfirmVisible(true);
    //             }}
    //             loading={updateLoading}
    //           >
    //             Approve
    //           </ButtonFilled>
    //         </div>
    //       )
    //     );
    //   },
    // },
    ...(hasActionableRecords
      ? [
          {
            title: t("Action"),
            key: "action",
            width: 180,
            render: (_, record) => {
              return (
                record?.statusId === "0" && (
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      justifyContent: "flex-end",
                    }}
                  >
                    <ButtonOutlined
                      onClick={() => {
                        setSelectedRecord(record);
                        setOpen(false);
                        setLeaveListModalVisible(false);
                        setIsOpenModal(true);
                      }}
                    >
                      Decline
                    </ButtonOutlined>
                    <ButtonFilled
                      onClick={() => {
                        setSelectedRecord(record);
                        setLeaveListModalVisible(false);
                        setApproveConfirmVisible(true);
                      }}
                      loading={updateLoading}
                    >
                      Approve
                    </ButtonFilled>
                  </div>
                )
              );
            },
          },
        ]
      : []),
  ];
  const hasActionableTimeOff = selectedEventDetails?.some(
    (record) => record?.statusId === "0"
  );
  const timeOffColumns = [
    {
      title: t("Name"),
      dataIndex: "userId",
      key: "timeoff_name",
      render: (text) => users?.find((val) => val?.userid === text)?.fullname,
    },
    {
      title: t("Employee ID"),
      dataIndex: "userId",
      key: "timeoff_empid",
      render: (text) => users?.find((val) => val?.userid === text)?.employeeid,
    },
    {
      title: t("Date - Day"),
      dataIndex: "permissionDate",
      key: "permissionDate",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Time"),
      dataIndex: "permissionTime",
      key: "permissionTime",
      render: (date) => dayjs(date)?.format("HH [hrs] mm [mins]"),
    },
    {
      title: t("Day to Compensate"),
      dataIndex: "compensatingDate",
      key: "compensatingDate",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "timeoff_file",
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record, "permissionrequest");
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Applied on"),
      dataIndex: "createdAt",
      key: "timeoff_createdAt",
      render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
    },
    {
      title: t("Reason for Time Off in Lieu"),
      dataIndex: "permissionReason",
      key: "permissionReason",
      className: "reason-column",
    },
    // {
    //   title: t("Action"),
    //   key: "timeoff_action",
    //   width: 180,
    //   render: (_, record) => {
    //     return (
    //       record?.statusId === "0" && (
    //         <div
    //           style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
    //         >
    //           <ButtonOutlined
    //             onClick={() => {
    //               setSelectedRecord(record);
    //               setOpen(false);
    //               setLeaveListModalVisible(false);
    //               setIsOpenModal(true);
    //             }}
    //           >
    //             Decline
    //           </ButtonOutlined>
    //           <ButtonFilled
    //             onClick={() => {
    //               setSelectedRecord(record);
    //               setLeaveListModalVisible(false);
    //               setApproveConfirmVisible(true);
    //             }}
    //             loading={updateLoading}
    //           >
    //             Approve
    //           </ButtonFilled>
    //         </div>
    //       )
    //     );
    //   },
    // },
    ...(hasActionableTimeOff
      ? [
          {
            title: t("Action"),
            key: "timeoff_action",
            width: 180,
            render: (_, record) => {
              return (
                record?.statusId === "0" && (
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      justifyContent: "flex-end",
                    }}
                  >
                    <ButtonOutlined
                      onClick={() => {
                        setSelectedRecord(record);
                        setOpen(false);
                        setLeaveListModalVisible(false);
                        setIsOpenModal(true);
                      }}
                    >
                      Decline
                    </ButtonOutlined>
                    <ButtonFilled
                      onClick={() => {
                        setSelectedRecord(record);
                        setLeaveListModalVisible(false);
                        setApproveConfirmVisible(true);
                      }}
                      loading={updateLoading}
                    >
                      Approve
                    </ButtonFilled>
                  </div>
                )
              );
            },
          },
        ]
      : []),
  ];

  function buildEventMap() {
    const map = {};

    const add = (dateStr, entry) => {
      if (!dateStr) return;
      const d = dayjs(dateStr);
      if (!d.isValid()) return;
      const key = `${d.year()}-${d.month() + 1}-${d.date()}`;
      if (!map[key]) map[key] = [];
      map[key].push(entry);
    };

    leaveList.forEach((item) => {
      const isPending =
        item.status_id === "4" || item.having_cancel_request === "1";

      const isApproved =
        item.status_id === "5" && item.having_cancel_request !== "1";

      let start = dayjs(
        item.new_start_date &&
          item.new_start_date !== "null" &&
          item.new_start_date !== null
          ? item.new_start_date
          : item.start_date
      );

      let end = dayjs(
        item.new_end_date &&
          item.new_end_date !== "null" &&
          item.new_end_date !== null
          ? item.new_end_date
          : item.end_date
      );

      while (start.isSameOrBefore(end, "day")) {
        const key = `${start.year()}-${start.month() + 1}-${start.date()}`;

        if (!map[key]) {
          map[key] = [
            {
              IconComponent: LeaveIcon,
              label: "Leave",
              green: 0,
              orange: 0,
              type: "leave",
              details: [],
            },
          ];
        }

        const event = map[key].find((e) => e.type === "leave");

        if (isApproved) event.green += 1;
        if (isPending) event.orange += 1;

        event.details.push(item);

        start = start.add(1, "day");
      }
    });

    wfhList.forEach((item) => {
      const isPending = item.statusId === "0";
      const isApproved = item.statusId === "1";

      let start = dayjs(item.wfhStartDate);
      let end = dayjs(item.wfhEndDate || item.wfhStartDate);

      while (start.isSameOrBefore(end, "day")) {
        const key = `${start.year()}-${start.month() + 1}-${start.date()}`;

        if (!map[key]) map[key] = [];

        let event = map[key].find((e) => e.type === "wfh");

        if (!event) {
          event = {
            IconComponent: HomeIcon,
            label: "WFH",
            green: 0,
            orange: 0,
            type: "wfh",
            details: [],
          };
          map[key].push(event);
        }

        if (isApproved) event.green += 1;
        if (isPending) event.orange += 1;
        event.details.push(item);
        start = start.add(1, "day");
      }
    });

    timeoffList.forEach((item) => {
      const isPending = item.statusId === "0";
      const isApproved = item.statusId === "1";

      const d = dayjs(item.permissionDate);
      const key = `${d.year()}-${d.month() + 1}-${d.date()}`;

      if (!map[key]) map[key] = [];

      let event = map[key].find((e) => e.type === "timeoff");

      if (!event) {
        event = {
          IconComponent: TimeoffIcon,
          label: "Time Off in Lieu",
          green: 0,
          orange: 0,
          type: "timeoff",
          details: [],
        };
        map[key].push(event);
      }

      if (isApproved) event.green += 1;
      if (isPending) event.orange += 1;
      event.details.push(item);
    });

    overtimeList.forEach((item) => {
      const isPending = item.statusId === "0";
      const isApproved = item.statusId === "1";

      const d = dayjs(item.overtimeDate);
      const key = `${d.year()}-${d.month() + 1}-${d.date()}`;

      if (!map[key]) map[key] = [];

      let event = map[key].find((e) => e.type === "overtime");

      if (!event) {
        event = {
          IconComponent: OvertimeIcon,
          label: "Overtime",
          green: 0,
          orange: 0,
          type: "overtime",
          details: [],
        };
        map[key].push(event);
      }

      if (isApproved) event.green += 1;
      if (isPending) event.orange += 1;
      event.details.push(item);
    });

    return map;
  }

  const EVENT_MAP = buildEventMap();

  const TODAY = dayjs();

  function isToday(date) {
    return (
      date.year() === TODAY.year() &&
      date.month() === TODAY.month() &&
      date.date() === TODAY.date()
    );
  }

  const renderPopoverContent = (event, list) => {
    console.log("eventdetails-->", event);
    return (
      <StyledDiv style={{ maxWidth: event.type === "timeoff" ? 600 : 320 }}>
        {event.type === "timeoff" ? (
          <>
            <b>{t("Timeoff in Lieu Details")}</b>
            <StyledTable
              className="mt-2"
              columns={timeOffColumns}
              dataSource={list}
              pagination={false}
              rowKey={(r, idx) => idx}
            />
          </>
        ) : (
          <>
            {event.details.map((item, i) => (
              <div key={i} style={{ marginBottom: 6 }}>
                <b>
                  {event.type === "wfh" ? "WFH Details" : "Overtime Details"}
                </b>
                <div>
                  {event.type === "leave" && (
                    <>
                      {item.fullname} <br />
                      {item.leave_category_name} <br />
                      Status: {item.status_name}
                    </>
                  )}

                  {event.type === "wfh" && (
                    <>
                      <Row gutter={[8, 14]}>
                        <Col xs={24} sm={12}>
                          <div className="label">Start Date</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">
                            {dayjs(item?.wfhStartDate)?.format(
                              "Do MMM YYYY - ddd"
                            )}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">End Date</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">
                            {dayjs(item?.wfhEndDate)?.format(
                              "Do MMM YYYY - ddd"
                            )}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Total Days</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">{item?.wfhNoofDays}</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Attachment</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div
                            className="value attachment"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePreviewClick(item, "wfhrequest");
                            }}
                          >
                            {item?.fileName || "-"}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Reason for WFH</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">{item?.wfhReason}</div>
                        </Col>
                      </Row>
                    </>
                  )}

                  {event.type === "overtime" && (
                    <>
                      <Row gutter={[8, 14]}>
                        <Col xs={24} sm={12}>
                          <div className="label">Date</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">
                            {dayjs(item?.overtimeDate)?.format(
                              "Do MMM YYYY - ddd"
                            )}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Time</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">
                            {dayjs(item?.overtimeTime)?.format(
                              "HH [hrs] mm [mins]"
                            )}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Attachment</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div
                            className="value attachment"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePreviewClick(item, "overtimerequest");
                            }}
                          >
                            {item?.fileName || "-"}
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="label">Reason for Overtime</div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="value">{item?.overtimeReason}</div>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </StyledDiv>
    );
  };

  const cancelLeave = (details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
    } = details;
    if (userRoleId !== 1 && status_id === "4") {
      Modal.confirm({
        icon: "",
        content: t("Are you sure you want to cancel your leave application?"),
        okText: t("YES"),
        cancelText: t("No"),
        onOk: () => {
          return new Promise(async (resolve) => {
            const payload = {
              userid: details?.userid,
              user_leave_id,
              status_id: "9",
              is_cancel_request: false,
              start_date: getMySqlDate(leave_start_date),
              end_date: getMySqlDate(leave_end_date),
            };
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                userid: details?.userid,
                user_leave_id,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(t("Oops!! something went wrong."));
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(t("Invalid payload. Please enter correct data."));
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(t("Leave already exist."));
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(t("Your leave application has been cancelled."));
              getLeaveList();
              // Call webhook API
            }
            resolve();
          }).catch((err) => console.log("[cancelLeave] Error-->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  function dateCellRender(current) {
    const { date: day } = dateInDetail(current);
    console.log("day-->", day, current);
    const key = `${current.year()}-${current.month() + 1}-${current.date()}`;
    const events = EVENT_MAP[key];

    const isHoliday = holidayList?.find(({ start_date, end_date }) =>
      isDateBetweenTwoDates(current, start_date, end_date)
    );

    const holidayColor = isHoliday?.color;

    const handleCellClick = (event, current) => {
      if (
        tabId === t("Mine") &&
        Menulist?.find(
          (item) => item?.key === "mycalendar" && item?.permission?.create
        )
      ) {
        addLeave(event, current);
      }
    };

    return (
      <StyledDateCell
      // onClick={(event) => handleCellClick(event, current)}
      >
        <div style={{ minHeight: 100 }}>
          {holidayColor && (
            <StyledHolidayBadge
              status="success"
              size="small"
              color={holidayColor}
            >
              H
            </StyledHolidayBadge>
          )}
          {events &&
            events.map((ev, i) => {
              const Icon = ev.IconComponent;
              const leaveDetails = ev?.details?.[0];

              const handleClick = (status) => {
                if (
                  tabId !== t("Mine") ||
                  (tabId === t("Mine") && ev.type === "timeoff")
                ) {
                  if (ev.type === "leave") {
                    setSelectedDate(current.format("YYYY-MM-DD"));
                    toggleLeaveListModalVisible(true);
                    setStatus(status);
                  } else {
                    const actualStatus = status === "approved" ? "1" : "0";

                    setSelectedType(ev.type);
                    setSelectedEventDetails(
                      ev.details?.filter(
                        (item) => item?.statusId === actualStatus
                      ) || []
                    );

                    setLeaveListModalVisible(true);
                  }
                }
              };

              const badgeRow = (
                <div key={i} style={styles.eventRow} title={ev.label}>
                  {ev.green > 0 && (
                    <span
                      style={{
                        ...styles.badge,
                        ...styles.leftBadge,
                        color: "#4caf50",
                      }}
                      onMouseEnter={() => setHoverStatus("1")}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick("approved");
                      }}
                    >
                      {ev.green}
                    </span>
                  )}

                  <span style={styles.iconWrap}>
                    <Icon />
                  </span>

                  {ev.orange > 0 && (
                    <span
                      style={{
                        ...styles.badge,
                        ...styles.rightBadge,
                        color: "#f57c00",
                      }}
                      onMouseEnter={() => setHoverStatus("0")}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick("pending");
                      }}
                    >
                      {ev.orange}
                    </span>
                  )}
                </div>
              );

              if (tabId === t("Mine") && ev.type === "leave") {
                return (
                  <StaffLeaveIndicatorInCalendar
                    key={i}
                    leaveDetails={leaveDetails}
                    isStaff={true}
                    day={day}
                    openEditLeaveModal={() => {
                      setLeaveDetails(leaveDetails);
                      toggleLeaveModal(true);
                    }}
                    EditLeaveModal={(details) => {
                      cancelLeave(details);
                    }}
                    handleEditIconClick={handleEditIconClick}
                  >
                    {badgeRow}
                  </StaffLeaveIndicatorInCalendar>
                );
              }

              if (tabId === t("Mine") && ev.type === "timeoff") {
                console.log("ev12-->", ev);
                return (
                  <Popover
                    key={i}
                    content={renderPopoverContent(
                      ev,
                      ev?.details?.filter(
                        (item) => item?.statusId === hoverStatus
                      )
                    )}
                    trigger="hover"
                    // overlayStyle={{ width: 600 }}
                  >
                    {badgeRow}
                  </Popover>
                );
              }

              if (tabId === t("Mine")) {
                return (
                  <Popover
                    key={i}
                    content={renderPopoverContent(ev)}
                    trigger="hover"
                  >
                    {badgeRow}
                  </Popover>
                );
              }

              return (
                <div
                  style={{ display: "flex", justifyContent: "center" }}
                  key={i}
                >
                  {badgeRow}
                </div>
              );
            })}
        </div>
      </StyledDateCell>
    );
  }

  const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div>
      <StyledAntCalendarFull
        key={calendarKey}
        value={momentDate(miniCalendarCurrentDate)}
        // Clicking a greyed-out day from the previous/next month makes antd
        // switch its grid to that month while the page header (and data)
        // stay on the selected month; remount to snap the grid back.
        onSelect={(date) => {
          const current = momentDate(miniCalendarCurrentDate);
          if (
            date?.month() !== current?.month() ||
            date?.year() !== current?.year()
          ) {
            setCalendarKey((key) => key + 1);
          }
        }}
        fullscreen={true}
        headerRender={() => null}
        dateCellRender={dateCellRender}
      />
      <LeaveList
        isModalVisible={isLeaveListModalVisible}
        closeModal={() => toggleLeaveListModalVisible(false)}
        date={selectedDate}
        status_id={
          status === "pending" ? "4" : status === "approved" ? "5" : ""
        }
        department_id={""}
        tabId={tabId}
        getLeaveLists={getLeaveList}
      />

      <Modal
        title={
          selectedType === "wfh"
            ? t("WFH Details")
            : selectedType === "timeoff"
            ? t("Timeoff in Lieu Details")
            : t("Overtime Details")
        }
        open={leaveListModalVisible}
        onCancel={() => setLeaveListModalVisible(false)}
        footer={null}
        width={700}
      >
        {selectedType === "wfh" && (
          <StyledTable
            columns={wfhColumns}
            dataSource={selectedEventDetails}
            rowKey={(record, index) => {
              console.log("record-->", record);
              return index;
            }}
            pagination={false}
          />
        )}
        {selectedType === "timeoff" && (
          <StyledTable
            columns={timeOffColumns}
            dataSource={selectedEventDetails}
            rowKey={(record, index) => index}
            pagination={false}
          />
        )}
        {selectedType === "overtime" && (
          <StyledTable
            columns={overtimeColumns}
            dataSource={selectedEventDetails}
            rowKey={(record, index) => index}
            pagination={false}
          />
        )}
      </Modal>
      <ModalWrap
        title=""
        visible={isOpenModal}
        centered
        keyboard={false}
        maskClosable={false}
        width={400}
        footer={[]}
        onCancel={() => setIsOpenModal(false)}
      >
        <Form
          form={updateform}
          name="reasonform"
          layout="vertical"
          initialValues={{ reason: "" }}
          onFinish={(values) => handleFinish("2", selectedRecord, values)}
        >
          <Form.Item
            label="Reason for Rejection"
            name="decline_reason"
            rules={[
              {
                required: true,
                pattern: NON_EMPTY_REGEX,
                message: "Please enter reject reason!",
              },
            ]}
          >
            <TextArea rows={4} placeholder="Type something.." maxLength={500} />
          </Form.Item>
          <div className="align-right">
            <ButtonOutlined onClick={() => setIsOpenModal(false)}>
              Cancel
            </ButtonOutlined>
            <ButtonFilled
              htmlType="submit"
              type="primary"
              loading={updateLoading}
            >
              Decline
            </ButtonFilled>
          </div>
        </Form>
      </ModalWrap>

      <Modal
        title="Confirm Approval"
        open={approveConfirmVisible}
        onCancel={() => {
          setApproveConfirmVisible(false);
          setSelectedRecord(null);
        }}
        footer={[
          <ButtonOutlined
            key="cancel"
            onClick={() => {
              setApproveConfirmVisible(false);
              setSelectedRecord(null);
            }}
          >
            Cancel
          </ButtonOutlined>,
          <ButtonFilled
            key="confirm"
            loading={updateLoading}
            onClick={() => {
              handleFinish("1", selectedRecord);
            }}
          >
            Confirm Approve
          </ButtonFilled>,
        ]}
        centered
        width={400}
      >
        <p>Are you sure you want to approve this request?</p>
      </Modal>

      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type={
          updateform?.getFieldValue("decline_reason") ? "decline" : "success"
        }
        message={
          updateform?.getFieldValue("decline_reason") ? "Declined" : "Approved"
        }
      />
    </div>
  );
}

const styles = {
  eventRow: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 3,
    width: 40,
    height: 20,
  },

  iconWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: 16,
  },

  badge: {
    position: "absolute",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1,
    cursor: "pointer",
  },

  leftBadge: {
    left: 0,
  },

  rightBadge: {
    right: 0,
  },
};
